import { render, staticRenderFns } from "./trip-item.html?vue&type=template&id=2306b572&scoped=true&"
import script from "./trip-item.js?vue&type=script&lang=js&"
export * from "./trip-item.js?vue&type=script&lang=js&"
import style0 from "./trip-item.scss?vue&type=style&index=0&id=2306b572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2306b572",
  null
  
)

export default component.exports